import FilledButton from "components/InterstellrComponents/FilledButton";

const DashboardCountCard = ({
  icon,
  title,
  count,
  backgroundColor = "#5153F5",
  onTap = null,
  actionText = null,
}) => {
  return (
    <div className="h-full w-full rounded-2xl border border-gray-200 bg-white shadow-sm">
      <div
        style={{
          backgroundColor: backgroundColor,
        }}
        className="flex flex-row justify-start items-center border-b border-gray-200 rounded-t-2xl px-4 pb-4 pt-4"
      >
        {icon}
        <h6 className="text-base font-semibold text-white">{title}</h6>
      </div>

      <div className="flex items-end justify-between px-4 py-4">
        <div>
          <h2 className="text-2xl font-normal leading-none text-gray-700">
            {count ?? 0}
          </h2>
        </div>
      </div>

      {onTap ? (
        <div className="px-4 pb-4">
          <FilledButton text={actionText} borderRadius={96} onPress={onTap} />
        </div>
      ) : null}
    </div>
  );
};

export default DashboardCountCard;
